import {Controller} from '@hotwired/stimulus';

const DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
const MONTHS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        contactExpiresAtTimestamp: Number,
    }

    static targets = [
        'timeLeft',
        'timeLeftContainer',
    ]

    interval = null;

    connect() {
        this.interval = setInterval(() => {
            if (false === this.calculate()) {
                clearInterval(this.interval);

                this.timeLeftContainerTarget.remove();
            }
        }, 30000);
    }

    disconnect() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    calculate() {
        const currentTimestamp = new Date().getTime();
        const timeLeft = (this.contactExpiresAtTimestampValue * 1000) - currentTimestamp;

        if (timeLeft < 0) {
            return false;
        }

        const hours = Math.floor(timeLeft / (1000 * 60 * 60));

        if (hours >= 24) {
            this.timeLeftTarget.innerHTML = this.formatAsDate();
        } else {
            this.timeLeftTarget.innerHTML = this.formatAsCountdown(hours, timeLeft);
        }

        return true;
    }

    formatAsCountdown(hours, timeLeft) {
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));

        // Must stay in sync with the server-side first paint in
        // messages-conversation.html.twig. Skipping a part outright left the label
        // reading "Il vous reste  pour traiter cette demande" under 1h01.
        const timeInText = hours > 0
            ? hours + 'h ' + minutes + 'min'
            : minutes + 'min';

        return translations['messages.You have']
            + timeInText
            + translations['messages.left to respond to this request'];
    }

    formatAsDate() {
        const expiryDate = new Date(this.contactExpiresAtTimestampValue * 1000);
        const dayOfWeek = translations['messages.day.' + DAYS[expiryDate.getDay()]];
        const dayOfMonth = expiryDate.getDate();
        const month = translations['messages.month.' + MONTHS[expiryDate.getMonth()]];
        const expiryHours = expiryDate.getHours();
        const expiryMinutes = String(expiryDate.getMinutes()).padStart(2, '0');

        return translations['messages.You have until']
            + dayOfWeek + ' ' + dayOfMonth + ' ' + month + ' ' + expiryHours + 'h' + expiryMinutes
            + translations['messages.to respond to this request'];
    }
}
